import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0 mb-3"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    attrs: {
      "items": _vm.contents,
      "headers": _vm.tblHeaders,
      "search": _vm.searchItem,
      "footer-props": _vm.tableFooterProps,
      "expanded": _vm.expanded,
      "item-key": "eui",
      "hide-default-header": ""
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function ({
        props
      }) {
        return _vm._l(props.headers, function (header, key) {
          return _c('th', {
            key: key
          }, [_vm._v("\n        " + _vm._s(header.text) + "\n        "), header.icon ? _c(VIcon, {
            attrs: {
              "small": ""
            }
          }, [_vm._v("fal " + _vm._s(header.icon))]) : _vm._e()], 1);
        });
      }
    }, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": _vm.tblHeaders.length + 2
          }
        }, [_c('div', {
          staticClass: "px-2 highlighted"
        }, [_c('p', {
          staticClass: "text-overline pt-1 mb-0"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.statusErrorMsg')))]), _vm._v("\n            " + _vm._s(props.item.msg) + "\n          ")])])])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };